import React from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./Post.css";
import clap from "../../assets/images/clap.svg";
import share from "../../assets/images/share.svg";
import { ClapButton } from "../ClapButton/ClapButton";
import { getReadingTime, getUser } from "../../common/helper";
import { isAndroid, isIOS, isMobile, isBrowser } from "react-device-detect";
import moment from "moment";

export default function Post({ details, onClapClick, userClapCount, index }) {
  const userId = Boolean(getUser());
  const readingTimeInMins = getReadingTime(details.post_character_count);
  const feedCreatedAt = moment(details.createdAt).format("DD MMM'YYYY");

  const onShare = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    const feed_title = details.feed_title.replace(/ /g, "-");
    const feedUrl = `${window.location.origin}/post/${details.feed_id}/${feed_title}`;
    if (isMobile) {
      let message = {
        msg: details.share_message,
        url: feedUrl,
      };
      message = JSON.stringify(message);

      if (isIOS) {
        window.location = `share://?${message}`;
      }
      /*eslint-disable no-undef*/
      if (isAndroid) {
        Android.shareBtnClicked(
          details.feed_image,
          `${details.share_message} ${feedUrl}`
        );
      }
    }
  };

  return (
    <div
      className={`post shadow-md hover:shadow-xl rounded-[24px] mb-[24px] ${
        index == 0 ? "mt-[32px]" : ""
      }`}
    >
      <div className="post-img-container relative">
        <span
          className="absolute top-7 right-1 z-10 h-[50px] w-[50px]"
          onClick={onShare}
        >
          <img
            src={share}
            alt="Share"
            className="drop-shadow-lg hover:drop-shadow-xl shareIconDimension"
          />
        </span>
        <LazyLoadImage
          src={details.feed_image}
          alt="feed"
          effect="blur"
          className="rounded-t-[24px] w-full"
        />
      </div>
      <div className="relative">
        {!isBrowser && userId && (
          <ClapButton
            onClapClick={onClapClick}
            feedId={details.feed_id}
            userClapCount={userClapCount}
          />
        )}
      </div>
      <div className="p-4">
        <h2 className="text-base font-semibold w-5/6 mb-[6px]">
          {details.feed_title}
        </h2>
        <div className="pt-4 flex justify-between text-gray-400 text-xs font-normal mb-[8px]">
          <div>
            {readingTimeInMins} {"min read "} &#x2022; {" " + feedCreatedAt}
          </div>
          <div className="flex items-center">
            <span className="pr-1">{details.total_clap_count} </span>
            <span>
              {" "}
              <img src={clap} className="w-5 h-5" alt="clap-icon" />
            </span>
          </div>
        </div>
        <div className="text-gray-400 text-sm mb-[20px]">
          {details.feed_brief}
        </div>
      </div>
    </div>
  );
}
